module.exports = __webpack_public_path__ + "media/images/dynamic-fields-empty-d82ff891b26327fbafd28d733f53a4cd.svg";